import React, { useEffect, useState, useRef } from "react";
import { useCachedApi } from "../../../hooks/useCachedApi";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

import axios from "axios";
import { Box, Container, Typography, IconButton, Skeleton } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {
  add_property,
  delete_old_image_residential,
  get_agents,
  get_amenities,
  get_city,
  get_nearby_place,
  get_owners,
  get_plot_store,
  get_state,
  get_country,
  my_plot_category,
  my_plot_facility,
  update_property,
  update_residential_property,
  update_residential_store,
} from "../../../api/ControllApi";
import { get_property_type, get_property } from "../../../api/ControllApi";

import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  TextField
} from "@mui/material";
import {
  GoogleMap,
  MarkerF,
  useJsApiLoader,
  Autocomplete as GMapAutocomplete
} from "@react-google-maps/api";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import GridOnIcon from "@mui/icons-material/GridOn";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { assetUrl, ASSET_BASE } from "../../../utils/baseUrls";

const IMAGE_BASE_URL = ASSET_BASE;
const MAPS_LIBRARIES = ["places"];
const getFullImageUrl = (url) => {
  if (!url) return "/assets/images/no-image.png";
  if (url.startsWith("http")) return url;
  return `${IMAGE_BASE_URL}${url}`;
};

const parseGalleryImages = (raw) => {
  try {
    if (!raw || !Array.isArray(raw) || raw.length === 0) return [];

    let allParsed = [];

    raw.forEach(item => {
      if (typeof item === "string" && item.includes("[")) {
        // Handle malformed JSON inside the string
        const jsonPart = item.match(/\[.*\]/s)?.[0];
        if (jsonPart) {
          try {
            const decoded = jsonPart.replace(/&quot;/g, '"');
            const parsed = JSON.parse(decoded);
            if (Array.isArray(parsed)) allParsed = [...allParsed, ...parsed];
            else allParsed.push(parsed);
          } catch (e) {
            allParsed.push(item);
          }
        } else {
          allParsed.push(item);
        }
      } else {
        allParsed.push(item);
      }
    });

    return allParsed.map((item) => {
      const url = typeof item === "string" ? item : item.url;
      const isVideo = url && /\.(mp4|webm|ogg|mov|quicktime)$/i.test(url.split("?")[0]);
      return {
        url: getFullImageUrl(url),
        type: isVideo ? "video" : "image"
      };
    });
  } catch (err) {
    console.error("Error parsing gallery images", err);
    return [];
  }
};


export default function AddResidential() {
  const { clearCache } = useCachedApi();
  const [loading, setLoading] = useState(false);

  const buttonStyle = {
    position: "absolute",
    top: -5,
    right: -5,
    background: "transparent",
    color: "#000",
    border: "1px solid #000",
    borderRadius: "50%",
    width: 16,
    height: 16,
    fontSize: 10,
    cursor: "pointer",
  };

  const [loadEdit, setLoadEdit] = useState(false);
  const galleryInputRef = useRef(null);
  const threeDInputRef = useRef(null);
  const blueprintInputRef = useRef(null); // ✅ Blueprint ref
  const sitePlanInputRef = useRef(null); // ✅ Site plan ref

  const navi = useNavigate();
  const { id } = useParams();

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [oldImages, setOldImages] = useState([]);
  const [oldImageApi, setOldImageApi] = useState([]);
  const [oldPlot, setOldPlot] = useState(null);
  const [oldBlue, setOldBlue] = useState(null);
  const [old3DImage, setOld3DImage] = useState(null);
  const [oldBlueprint, setOldBlueprint] = useState(null); // ✅ Old blueprint from API
  const [oldSitePlan, setOldSitePlan] = useState(null); // ✅ Old site plan from API
  const [loadingEditData, setLoadingEditData] = useState(false);

  const [propertyType, setPropertyType] = useState([]);

  const [nearbyPlaces, setNearbyPlaces] = useState([]);

  const [amenities, setAmenities] = useState([]);
  const [facility, setFacility] = useState([]);
  const [facilityDocuments, setFacilityDocuments] = useState({});
  const [plotCategories, setPlotCategories] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const [facilityValues, setFacilityValues] = useState({});
  const [newGalleryPreviews, setNewGalleryPreviews] = useState([]);
  const [new3dimagePreview, setNew3dimagePreview] = useState(null);
  const [newBlueprintPreview, setNewBlueprintPreview] = useState(null); // ✅ New blueprint preview
  const [newSitePlanPreview, setNewSitePlanPreview] = useState(null); // ✅ New site plan preview

  const [form, setForm] = useState({
    name: "",
    country: "",
    state: "",
    city: "",
    address: "",
    price: "",
    area_sqft: "",
    area_sqft_price: "",
    plot_count: "",
    lat: "",
    lng: "",
    description: "",
    amenities: [],
    nearby: [{ place: "", distance: "" }],
    gallery_images: [],
    three_d_image: null,
    blueprint: null,
    // site_plan: null,
    highlights: "",
    overview: "",
    dimensions: "",
    facing: "",
    gated: false,
    open_sides: "",
    overlooking: "",
    transaction_type: "new",
    ownership: "",
    road_width: "",
    boundary_wall: false,
    features: "",
    handover_date: "",
    completion_date: "",
    youtube_link: "",
  });

  const location = useLocation();
  const editDataFromState = location.state;
  const [editData, setEditData] = useState([]);
  const isEdit = Boolean(id);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBMORJwqAENHll476u4UXGJmV_bSFJycA8",
    libraries: MAPS_LIBRARIES,
  });

  const handleMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    setForm((prev) => ({
      ...prev,
      lat: lat.toFixed(6),
      lng: lng.toFixed(6),
    }));

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        setForm((prev) => ({ ...prev, address: results[0].formatted_address }));
      } else {
        setForm({ ...form, lat, lng });
      }
    });
  };

  const containerStyle = { width: "100%", height: "300px" };
  const defaultCenter = { lat: 10.99835602, lng: 77.01502627 };

  const removeOldImage = (index) => {
    setOldImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAmenitiesChange = (event) => {
    const { target: { value } } = event;
    setForm((prev) => ({ ...prev, amenities: value }));
  };

  const handleNearbyChange = (index, field, value) => {
    setForm((prev) => ({
      ...prev,
      nearby: prev.nearby.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      ),
    }));
  };

  const addNearby = () => {
    if (form.nearby.some(n => !n.place)) {
      toast.error("Please select nearby place first");
      return;
    }
    setForm((prev) => ({
      ...prev,
      nearby: [...prev.nearby, { place: "", distance: "" }],
    }));
  };

  const removeNearby = (index) => {
    if (index === 0) return;
    setForm((prev) => ({
      ...prev,
      nearby: prev.nearby.filter((_, i) => i !== index),
    }));
  };

  const removeOldPlot = () => setOldPlot(null);
  const removeOldBlue = () => setOldBlue(null);

  useEffect(() => {
    if (!isEdit) return;
    if (isEdit && !editDataFromState) {
      setLoadingEditData(true);
      update_residential_property(id)
        .then((res) => { setEditData(res); })
        .catch((err) => { })
        .finally(() => setLoadingEditData(false));
    }
  }, [id, editDataFromState, isEdit]);

  useEffect(() => {
    if (form.state) getCity(form.state);
  }, [form.state]);

  useEffect(() => {
    if (!isEdit || !editData?.plot || (form.country && states.length === 0) || (form.state && cities.length === 0)) return;

    const plot = editData.plot;
    const mappedAmenities = plot.amenitiesall ? plot.amenitiesall.map(a => a.id) : [];
    const mappedNearby = plot.nearby_places?.length > 0
      ? plot.nearby_places.map((n) => ({ place: String(n.place_id), distance: String(n.distance) }))
      : [{ place: "", distance: "" }];
    const mappedDocuments = plot.documents ? JSON.parse(plot.documents) : [];
    const selectedCity = cities.find((c) => c.id === plot.city);

    setForm((prev) => ({
      ...prev,
      name: plot.property_name || "",
      address: plot.location || "",
      country: plot.country ? String(plot.country) : "",
      state: plot.state ? String(plot.state) : "",
      city: selectedCity ? String(selectedCity.id) : "",
      category_id: plot.category_id ? String(plot.category_id) : "",
      lat: plot.lat || "",
      lng: plot.lng || "",
      price: plot.price || "",
      area_sqft: plot.area_sqft || "",
      area_sqft_price: plot.area_sqft_price || "",
      plot_count: plot.plot_count || "",
      description: plot.about_property || "",
      amenities: mappedAmenities,
      nearby: mappedNearby,
      gallery_images: [],
      // site_plan: null,
      three_d_image: null,
      blueprint: null,
      documents: mappedDocuments,
      youtube_link: plot.youtube_link || "",
    }));

    setOldImages(parseGalleryImages(plot.gallery_images));
    setOldBlue(plot.construction_guidelines || null);
    setOld3DImage(plot.three_d_image || null);
    setOldBlueprint(plot.blueprint || null);
    // setOldSitePlan(plot.thumbnail || null); // Load thumbnail as old site plan
    setSelectedCategory(plot.category_id ? String(plot.category_id) : "");
  }, [isEdit, editData, states, cities]);

  useEffect(() => {
    if (!isEdit) return;
    if (!editData?.saved_facilities) return;
    if (!facilities || facilities.length === 0) return;

    const mappedValues = {};
    facilities.forEach((item) => {
      const savedValue = editData.saved_facilities[item.id];
      if (savedValue !== undefined && savedValue !== null) {
        mappedValues[item.id] = String(savedValue);
      }
    });
    setFacilityValues(mappedValues);

    const mappedDocuments = {};
    editData.documents?.forEach((doc) => {
      mappedDocuments[doc.document_id] = [{ name: doc.title, url: doc.value, isExisting: true }];
    });
    setFacilityDocuments(mappedDocuments);
  }, [isEdit, editData, facilities]);

  useEffect(() => {
    if (!isEdit) return;
    if (!editData?.plot?.facilities) return;
    const files = {};
    editData.plot.facilities.forEach((f) => {
      if (f.images) files[f.facility_id] = [f.images];
    });
    setFacilityDocuments(files);
  }, [isEdit, editData]);

  useEffect(() => {
    if (isEdit && selectedCategory) getFacility(selectedCategory);
  }, [isEdit, selectedCategory]);

  const getCountries = () => {
    get_country().then((res) => setCountries(res?.data || [])).catch(() => { });
  };

  const getState = (countryId) => {
    if (countryId) {
      get_state({ country_id: countryId }).then((res) => setStates(res?.data || [])).catch(() => { });
    } else {
      setStates([]);
    }
  };

  useEffect(() => {
    if (form.country) {
      getState(form.country);
    } else {
      setStates([]);
    }
  }, [form.country]);

  const getCity = async (value) => {
    try {
      const res = await get_city({ state_id: value });
      setCities(res?.data || []);
    } catch (err) {

    }
  };

  const getFileIcon = (fileName) => {
    const ext = fileName?.split(".").pop()?.toLowerCase();
    switch (ext) {
      case "pdf": return <PictureAsPdfIcon color="error" />;
      case "doc": case "docx": return <DescriptionIcon color="primary" />;
      case "xls": case "xlsx": return <GridOnIcon color="success" />;
      default: return <InsertDriveFileIcon />;
    }
  };

  const getCategory = () => {
    my_plot_category().then((res) => setPlotCategories(res?.data)).catch(() => { });
  };

  const getFacility = (value) => {
    my_plot_facility(value).then((res) => setFacilities(res?.data)).catch(() => { });
  };

  const getNearbyList = () => {
    get_nearby_place().then((res) => setNearbyPlaces(res.data.nearby_places)).catch(() => { });
  };

  const getNAmenitiesList = () => {
    get_amenities().then((res) => setAmenities(res.data.amenities)).catch(() => { });
  };

  useEffect(() => {
    getCountries();
    getNearbyList();
    getNAmenitiesList();
    getCategory();
  }, []);

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;

    if (!files) {
      setForm((prev) => {
        const updated = { ...prev, [name]: type === "checkbox" ? checked : value };
        if (name === "country") {
          updated.state = "";
          updated.city = "";
          setCities([]);
        }
        if (name === "state") {
          updated.city = "";
        }
        return updated;
      });
      return;
    }

    if (name === "gallery_images") {
      const fileArray = Array.from(files);
      const allowedTypes = [
        "image/jpeg", "image/jpg", "image/png", "image/jfif",
        "video/mp4", "video/webm", "video/ogg", "video/quicktime"
      ];
      const filteredFiles = fileArray.filter((file) => allowedTypes.includes(file.type));

      if (filteredFiles.length === 0) {
        toast.error("Only images (jpg, jpeg, png, jfif) and videos are allowed.");
        e.target.value = null;
        return;
      }

      setForm((prev) => ({
        ...prev,
        gallery_images: [...(prev.gallery_images || []), ...filteredFiles],
      }));
      setNewGalleryPreviews((prev) => [
        ...prev,
        ...filteredFiles.map((file) => URL.createObjectURL(file)),
      ]);
      if (galleryInputRef.current) galleryInputRef.current.value = null;
      return;
    }

    if (["three_d_image", "blueprint"].includes(name)) {
      const file = files[0];
      const allowedTypes = [
        "image/jpeg", "image/jpg", "image/png", "image/jfif",
        "video/mp4", "video/webm", "video/ogg", "video/quicktime"
      ];

      if (!allowedTypes.includes(file.type)) {
        toast.error("Only images (jpg, jpeg, png, jfif) and videos are allowed.");
        e.target.value = null;
        return;
      }

      setForm((prev) => ({ ...prev, [name]: file }));

      if (name === "three_d_image") {
        setOld3DImage(null);
        setNew3dimagePreview(URL.createObjectURL(file));
      }
      if (name === "blueprint") {
        setOldBlueprint(null);
        setNewBlueprintPreview(URL.createObjectURL(file));
      }
      return;
    }
  };

  const selectedNearbyIds = form.nearby.map((n) => n.place).filter(Boolean);

  const autocompleteRef = useRef(null);
  const mapRef = useRef(null);

  const onLoadMap = (map) => { mapRef.current = map; };
  const onLoadAutocomplete = (autocomplete) => { autocompleteRef.current = autocomplete; };

  const onPlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();
    if (!place.geometry || !place.geometry.location) return;
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    setForm((prev) => ({ ...prev, address: place.formatted_address, lat, lng }));
    if (mapRef.current) {
      mapRef.current.panTo({ lat, lng });
      mapRef.current.setZoom(15);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = ["name", "address", "price", "area_sqft_price", "plot_count", "description", "country", "state", "city"];
    for (let field of requiredFields) {
      if (!form[field] || form[field].toString().trim() === "") {
        const label = field.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
        toast.error(`Please fill the ${label} field.`);
        return;
      }
    }

    if (form.nearby.length === 0) { toast.error("Please add at least one nearby place"); return; }
    if (!form.lat) { toast.error("Select in Map"); return; }
    if (!form.lng) { toast.error("Select in Map"); return; }

    for (const n of form.nearby) {
      if (!n.place || !n.distance) {
        toast.error("Nearby places must have place and distance");
        return;
      }
    }

    if (!form.amenities || form.amenities.length === 0) {
      toast.error("Please select at least one amenity");
      return;
    }

    if (!isEdit && (!form.gallery_images || form.gallery_images.length === 0)) {
      toast.error("Please upload at least one gallery image.");
      return;
    }
    if (isEdit && oldImages.length === 0 && (!form.gallery_images || form.gallery_images.length === 0)) {
      toast.error("Please upload at least one gallery image.");
      return;
    }

    if (!isEdit && !form.three_d_image) { toast.error("Please upload the 3D image."); return; }
    if (isEdit && !form.three_d_image && !old3DImage) { toast.error("Please upload the 3D image."); return; }

    // ✅ Blueprint validation
    if (!isEdit && !form.blueprint) { toast.error("Please upload the Blueprint image."); return; }
    if (isEdit && !form.blueprint && !oldBlueprint) { toast.error("Please upload the Blueprint image."); return; }

    for (let item of facilities) {
      if (item.is_required === 1) {
        const value = facilityValues[item.id];
        const docs = facilityDocuments[item.id];
        if (["text", "dropdown", "radio"].includes(item.type)) {
          if (!value || value.toString().trim() === "") {
            toast.error(`Please fill the ${item.name} field.`);
            return;
          }
        }
        if (item.type === "file") {
          if (!docs || docs.length === 0) {
            toast.error(`Please upload file(s) for ${item.name}.`);
            return;
          }
        }
      }
    }

    setLoading(true);

    try {
      const formData = new FormData();

      if (isEdit) formData.append("id", id);

      formData.append("property_name", form.name);
      formData.append("category_id", selectedCategory);
      formData.append("location", form.address);
      formData.append("lat", form.lat);
      formData.append("lng", form.lng);
      formData.append("price", form.price);
      formData.append("area_sqft", form.area_sqft);
      formData.append("area_sqft_price", form.area_sqft_price);
      formData.append("plot_count", form.plot_count);
      formData.append("about_property", form.description);
      formData.append("user_type", "customer");
      formData.append("country", form.country);
      formData.append("state", form.state);
      formData.append("city", form.city);

      // Append all additional fields
      formData.append("highlights", form.highlights || "");
      formData.append("overview", form.overview || "");
      formData.append("dimensions", form.dimensions || "");
      formData.append("facing", form.facing || "");
      formData.append("gated", form.gated ? "1" : "0");
      formData.append("open_sides", form.open_sides || "");
      formData.append("overlooking", form.overlooking || "");
      formData.append("transaction_type", form.transaction_type || "");
      formData.append("ownership", form.ownership || "");
      formData.append("road_width", form.road_width || "");
      formData.append("boundary_wall", form.boundary_wall ? "1" : "0");
      formData.append("features", form.features || "");
      formData.append("handover_date", form.handover_date || "");
      formData.append("completion_date", form.completion_date || "");

      Object.keys(facilityValues).forEach(fid => {
        formData.append(`facilities[${fid}]`, facilityValues[fid]);
      });
      Object.keys(facilityDocuments).forEach(fid => {
        facilityDocuments[fid]?.forEach((file) => {
          if (file instanceof File) formData.append(`documents[${fid}]`, file);
        });
      });

      form.amenities.forEach((id) => formData.append("amenities[]", id));

      formData.append(
        "nearby_places",
        JSON.stringify(form.nearby.map(n => ({ place_id: Number(n.place), distance: Number(n.distance) })))
      );

      form.gallery_images.forEach((file) => {
        if (file instanceof File) formData.append("gallery_images[]", file);
      });

      if (form.three_d_image instanceof File) formData.append("three_d_image", form.three_d_image);
      if (form.blueprint instanceof File) formData.append("blueprint", form.blueprint);
      formData.append("youtube_link", form.youtube_link || "");

      let response;
      if (isEdit) {
        response = await update_residential_store(formData);
      } else {
        response = await get_plot_store(formData);
      }

      if (response.status === true) {
        toast.success(isEdit ? "Property updated successfully" : "Property added successfully");
        if (isEdit && id) clearCache(`plot_details_${id}`);
        navi("/dashboard/my_residential_property");
      } else {
        toast.error(response.error || "Something went wrong");
      }
    } catch (err) {
      toast.error(err?.response?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    setSelectedCategory(value);
    setFacilityValues({});
    setFacilityDocuments({});
    if (value) getFacility(value);
  };

  const handleFacilityChange = (facilityId, value) => {
    setFacilityValues((prev) => ({ ...prev, [facilityId]: value }));
  };

  const handleFacilityFileChange = (facilityId, files) => {
    const allowedTypes = [
      "image/jpeg", "image/png", "image/jpg", "image/gif",
      "video/mp4", "video/webm", "video/ogg", "video/quicktime",
      "application/pdf", "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/plain",
    ];
    const filteredFiles = Array.from(files).filter((file) => allowedTypes.includes(file.type));
    setFacilityDocuments((prev) => ({ ...prev, [facilityId]: filteredFiles }));
  };

  const handleDeleteOldImage = async (imagePath, index, id) => {
    const filename = imagePath.split("/").pop();
    const isVideo = oldImages[index]?.type === "video";
    try {
      await delete_old_image_residential(id, filename);
      setOldImages((prev) => prev.filter((_, i) => i !== index));
      toast.success(isVideo ? "Video removed successfully" : "Image removed successfully");
    } catch (err) {
      toast.error(isVideo ? "Failed to delete video" : "Failed to delete image");
    }
  };

  const removeGalleryImage = (index) => {
    setForm(prev => ({ ...prev, gallery_images: prev.gallery_images.filter((_, i) => i !== index) }));
    setNewGalleryPreviews(prev => prev.filter((_, i) => i !== index));
    if (galleryInputRef.current) galleryInputRef.current.value = null;
  };

  const remove3DImage = () => {
    setOld3DImage(null);
    setNew3dimagePreview(null);
    setForm(prev => ({ ...prev, three_d_image: null }));
    if (threeDInputRef.current) threeDInputRef.current.value = null;
  };

  // ✅ Remove blueprint handler
  const removeBlueprint = () => {
    setOldBlueprint(null);
    setNewBlueprintPreview(null);
    setForm(prev => ({ ...prev, blueprint: null }));
    if (blueprintInputRef.current) blueprintInputRef.current.value = null;
  };

  // ✅ Remove site plan handler
  const removeSitePlan = () => {
    setOldSitePlan(null);
    setNewSitePlanPreview(null);
    setForm(prev => ({ ...prev, site_plan: null }));
    if (sitePlanInputRef.current) sitePlanInputRef.current.value = null;
  };

  // ✅ Image fields config — added blueprint
  const imageFields = [
    { key: "gallery_images", label: "Gallery Images" },
    { key: "three_d_image", label: "3D Image" },
    { key: "blueprint", label: "Blueprint Image" },
    // { key: "site_plan", label: "Site Plan / Thumbnail" },
  ];

  return (
    <Container>
      <Box
        sx={{
          mx: "auto", mt: 6, mb: 6, p: 4,
          backgroundColor: "#f9f9f9",
          border: "1px solid #ddd",
          borderRadius: 3,
          boxShadow: 1,
        }}
      >
        <h3 className="mb-4 text-center">{isEdit ? "Edit" : "Add"} Flats / Villas Property</h3>

        {loadingEditData ? (
          <Row className="g-3">
            {Array.from({ length: 6 }).map((_, idx) => (
              <Col xs={12} md={6} key={idx}>
                <Skeleton variant="rectangular" height={56} />
              </Col>
            ))}
            <Col xs={12}><Skeleton variant="rectangular" height={100} /></Col>
          </Row>
        ) : (
          <Form onSubmit={handleSubmit}>
            {/* Row 1: Name, Category */}
            <Row className="g-3">
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Property Name <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control placeholder="Property Name" name="name" value={form.name} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group>
                  <Form.Label>Facility Category <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Select value={selectedCategory} onChange={handleCategoryChange}>
                    <option value="">Select Category</option>
                    {plotCategories.map((cat) => (
                      <option key={cat.id} value={cat.id}>{cat.category_name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {/* Row 2: Country, State, City */}
            <Row className="g-3">
              <Col xs={12} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Country <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Select name="country" value={form.country} onChange={handleChange}>
                    <option value="">Select Country</option>
                    {countries.map((item) => (
                      <option key={item.id} value={item.id}>{item.country_name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>State <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Select name="state" value={form.state} onChange={handleChange} disabled={!form.country}>
                    <option value="">Select State</option>
                    {states.map((item) => (
                      <option key={item.id} value={item.id}>{item.state_name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>City <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Select name="city" value={form.city} onChange={handleChange} disabled={!form.state}>
                    <option value="">Select City</option>
                    {cities.map(item => (
                      <option key={item.id} value={String(item.id)}>{item.city_name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {/* Row 3: Prices & Area */}
            <Row className="g-3">
              <Col xs={12} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Total Price (₹) <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control name="price" type="number" placeholder="Total Price" className="remove-number-arrows" value={form.price} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Total Area (Sqft) <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control name="area_sqft" type="number" className="remove-number-arrows" placeholder="Total Area" value={form.area_sqft} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Price per Sqft (₹) <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control name="area_sqft_price" type="number" className="remove-number-arrows" placeholder="Price per Sqft" value={form.area_sqft_price} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Plot / Unit Count <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control name="plot_count" type="number" className="remove-number-arrows" placeholder="Unit Count" value={form.plot_count} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>



            {/* Nearby Places */}
            <Row className="g-3 mb-3">
              {form.nearby.map((near, index) => {
                const filteredPlaces = nearbyPlaces.filter(
                  (place) =>
                    !selectedNearbyIds.includes(String(place.id)) ||
                    String(place.id) === String(near.place)
                );
                return (
                  <React.Fragment key={index}>
                    <Col xs={12} md={5}>
                      <Form.Group className="mb-3">
                        {index === 0 && <Form.Label>Nearby Place <span style={{ color: "red" }}>*</span></Form.Label>}
                        <Form.Select value={near.place} onChange={(e) => handleNearbyChange(index, "place", e.target.value)}>
                          <option value="">Select Nearby Place</option>
                          {filteredPlaces.map((place) => (
                            <option key={place.id} value={place.id}>{place.title}</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={5}>
                      <Form.Group className="mb-3">
                        {index === 0 && <Form.Label>Distance (km) <span style={{ color: "red" }}>*</span></Form.Label>}
                        <Form.Control
                          type="number"
                          placeholder="Enter distance"
                          className="remove-number-arrows"
                          value={near.distance}
                          onChange={(e) => handleNearbyChange(index, "distance", e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={2} className="d-flex align-items-end gap-2 mb-3">
                      {index === 0 && <Button variant="success" onClick={addNearby}>Add</Button>}
                      <Button variant="danger" onClick={() => removeNearby(index)}>Remove</Button>
                    </Col>
                  </React.Fragment>
                );
              })}
            </Row>

            {/* Address + Map */}
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Address <span style={{ color: "red" }}>*</span></Form.Label>
                  {isLoaded ? (
                    <GMapAutocomplete onLoad={onLoadAutocomplete} onPlaceChanged={onPlaceChanged}>
                      <Form.Control
                        placeholder="Search address"
                        value={form.address}
                        onChange={(e) => setForm({ ...form, address: e.target.value })}
                      />
                    </GMapAutocomplete>
                  ) : (
                    <Form.Control placeholder="Loading map..." disabled />
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                {isLoaded ? (
                  <GoogleMap
                    mapContainerStyle={{ width: "100%", height: "400px" }}
                    center={form.lat && form.lng ? { lat: Number(form.lat), lng: Number(form.lng) } : defaultCenter}
                    zoom={14}
                    onClick={handleMapClick}
                    options={{}}
                  >
                    {form.lat && form.lng && (
                      <MarkerF
                        position={{ lat: Number(form.lat), lng: Number(form.lng) }}
                        draggable={true}
                        onDragEnd={handleMapClick}
                      />
                    )}
                  </GoogleMap>
                ) : (
                  <div style={{ height: 300 }}>Loading Map...</div>
                )}
              </Col>
            </Row>

            {/* Description + Amenities */}
            <Row className="g-3">
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" style={{ marginTop: "30px" }}>
                  <Form.Label>Description <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control as="textarea" rows={3} name="description" value={form.description} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group style={{ marginTop: "30px" }}>
                  <Form.Label>Amenities <span style={{ color: "red" }}>*</span></Form.Label>
                  <Autocomplete
                    multiple
                    options={amenities}
                    getOptionLabel={(option) => option.title}
                    value={amenities.filter((a) => form.amenities.includes(a.id))}
                    onChange={(event, newValue) =>
                      setForm({ ...form, amenities: newValue.map((v) => v.id) })
                    }
                    disableCloseOnSelect
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} style={{ marginRight: 8 }} />
                        {option.title}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={form.amenities.length === 0 ? "Select Amenities" : ""}
                        sx={{ backgroundColor: "white", borderRadius: 1 }}
                        size="small"
                      />
                    )}
                    ListboxProps={{ style: { maxHeight: 48 * 4, overflowY: "auto" } }}
                    fullWidth
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* ✅ Image Upload Fields: Gallery, Thumbnail, 3D Image, Blueprint */}
            <Row className="g-3 mt-2">
              {imageFields.map(({ key, label }) => (
                <Col xs={12} md={3} key={key}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {label} <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*,video/*"
                      multiple={key === "gallery_images"}
                      name={key}
                      ref={
                        key === "gallery_images" ? galleryInputRef
                          : key === "three_d_image" ? threeDInputRef
                            : key === "blueprint" ? blueprintInputRef
                              : sitePlanInputRef
                      }
                      onChange={handleChange}
                    />

                    <div className="d-flex gap-2 mt-2 flex-wrap">
                      {/* Gallery Images */}
                      {key === "gallery_images" && (
                        <>
                          {oldImages.map((img, idx) => {
                            const fullImgUrl = getFullImageUrl(img.url);
                            const isVideo = img.type === "video";
                            return (
                              <div key={`old-${idx}`} style={{ position: "relative" }}>
                                {isVideo ? (
                                  <video src={fullImgUrl} width={70} height={60} muted autoPlay loop style={{ borderRadius: 4, objectFit: "cover" }} />
                                ) : (
                                  <img src={fullImgUrl} width={70} height={60} style={{ borderRadius: 4, objectFit: "cover" }} alt="" />
                                )}
                                <button type="button" onClick={() => handleDeleteOldImage(img.url, idx, id)} style={buttonStyle}>X</button>
                              </div>
                            );
                          })}
                          {newGalleryPreviews.map((preview, idx) => {
                            const file = form.gallery_images[idx];
                            const isVideo = file?.type?.startsWith("video/");
                            return (
                              <div key={`new-${idx}`} style={{ position: "relative" }}>
                                {isVideo ? (
                                  <video src={preview} width={70} height={60} muted autoPlay loop style={{ borderRadius: 4, objectFit: "cover" }} />
                                ) : (
                                  <img src={preview} width={70} height={60} style={{ borderRadius: 4, objectFit: "cover" }} alt="" />
                                )}
                                <button type="button" onClick={() => removeGalleryImage(idx)} style={buttonStyle}>X</button>
                              </div>
                            );
                          })}
                        </>
                      )}


                      {/* 3D Image */}
                      {key === "three_d_image" && (
                        <>
                          {old3DImage && !new3dimagePreview && (
                            <div style={{ position: "relative" }}>
                              {old3DImage.match(/\.(mp4|webm|ogg|mov|quicktime)$/i) ? (
                                <video src={getFullImageUrl(old3DImage)} width={70} height={60} muted autoPlay loop style={{ borderRadius: 4, objectFit: "cover" }} />
                              ) : (
                                <img src={getFullImageUrl(old3DImage)} width={70} height={60} style={{ borderRadius: 4, objectFit: "cover" }} alt="" />
                              )}
                              <button type="button" onClick={remove3DImage} style={buttonStyle}>X</button>
                            </div>
                          )}
                          {new3dimagePreview && (
                            <div style={{ position: "relative" }}>
                              {form.three_d_image?.type?.startsWith("video/") ? (
                                <video src={new3dimagePreview} width={70} height={60} muted autoPlay loop style={{ borderRadius: 4, objectFit: "cover" }} />
                              ) : (
                                <img src={new3dimagePreview} width={70} height={60} style={{ borderRadius: 4, objectFit: "cover" }} alt="" />
                              )}
                              <button type="button" onClick={remove3DImage} style={buttonStyle}>X</button>
                            </div>
                          )}
                          {!old3DImage && !new3dimagePreview && (
                            <small className="text-muted d-block mt-1">No 3D image uploaded</small>
                          )}
                        </>
                      )}

                      {/* ✅ Blueprint Image */}
                      {key === "blueprint" && (
                        <>
                          {oldBlueprint && !newBlueprintPreview && (
                            <div style={{ position: "relative" }}>
                              {oldBlueprint.match(/\.(mp4|webm|ogg|mov|quicktime)$/i) ? (
                                <video src={getFullImageUrl(oldBlueprint)} width={70} height={60} muted autoPlay loop style={{ borderRadius: 4, objectFit: "cover" }} />
                              ) : (
                                <img src={getFullImageUrl(oldBlueprint)} width={70} height={60} style={{ borderRadius: 4, objectFit: "cover" }} alt="" />
                              )}
                              <button type="button" onClick={removeBlueprint} style={buttonStyle}>X</button>
                            </div>
                          )}
                          {newBlueprintPreview && (
                            <div style={{ position: "relative" }}>
                              {form.blueprint?.type?.startsWith("video/") ? (
                                <video src={newBlueprintPreview} width={70} height={60} muted autoPlay loop style={{ borderRadius: 4, objectFit: "cover" }} />
                              ) : (
                                <img src={newBlueprintPreview} width={70} height={60} style={{ borderRadius: 4, objectFit: "cover" }} alt="" />
                              )}
                              <button type="button" onClick={removeBlueprint} style={buttonStyle}>X</button>
                            </div>
                          )}
                          {!oldBlueprint && !newBlueprintPreview && (
                            <small className="text-muted d-block mt-1">No blueprint uploaded</small>
                          )}
                        </>
                      )}

                      {/* ✅ Site Plan / Thumbnail */}
                      {/* {key === "site_plan" && (
                        <>
                          {oldSitePlan && !newSitePlanPreview && (
                            <div style={{ position: "relative" }}>
                              {oldSitePlan.match(/\.(mp4|webm|ogg|mov|quicktime)$/i) ? (
                                <video src={getFullImageUrl(oldSitePlan)} width={70} height={60} muted autoPlay loop style={{ borderRadius: 4, objectFit: "cover" }} />
                              ) : (
                                <img src={getFullImageUrl(oldSitePlan)} width={70} height={60} style={{ borderRadius: 4, objectFit: "cover" }} alt="" />
                              )}
                              <button type="button" onClick={removeSitePlan} style={buttonStyle}>X</button>
                            </div>
                          )}
                          {newSitePlanPreview && (
                            <div style={{ position: "relative" }}>
                              {form.site_plan?.type?.startsWith("video/") ? (
                                <video src={newSitePlanPreview} width={70} height={60} muted autoPlay loop style={{ borderRadius: 4, objectFit: "cover" }} />
                              ) : (
                                <img src={newSitePlanPreview} width={70} height={60} style={{ borderRadius: 4, objectFit: "cover" }} alt="" />
                              )}
                              <button type="button" onClick={removeSitePlan} style={buttonStyle}>X</button>
                            </div>
                          )}
                          {!oldSitePlan && !newSitePlanPreview && (
                            <small className="text-muted d-block mt-1">No site plan uploaded</small>
                          )}
                        </>
                      )} */}
                    </div>
                  </Form.Group>
                </Col>
              ))}
              {/* YouTube Link — next to 3D Image */}
              <Col xs={12} md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>YouTube Link</Form.Label>
                  <Form.Control
                    name="youtube_link"
                    type="url"
                    placeholder="Enter YouTube video URL"
                    value={form.youtube_link}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Dynamic Facilities */}
            <Row className="g-3 mt-3">
              {facilities.map((item) => (
                <Col md={6} key={item.id}>
                  <Form.Group>
                    <Form.Label>
                      {item.name}
                      {item.is_required === 1 && <span className="text-danger"> *</span>}
                    </Form.Label>

                    {item.type === "text" && (
                      <Form.Control value={facilityValues[item.id] || ""} onChange={(e) => handleFacilityChange(item.id, e.target.value)} />
                    )}

                    {item.type === "dropdown" && (
                      <Form.Select value={facilityValues[item.id] || ""} onChange={(e) => handleFacilityChange(item.id, e.target.value)}>
                        <option value="">Select</option>
                        {item.value?.split(",").map((opt) => (
                          <option key={opt} value={opt}>{opt}</option>
                        ))}
                      </Form.Select>
                    )}

                    {item.type === "radio" && (
                      <div className="d-flex gap-3 mt-1">
                        {item.value?.split(",").map((opt) => (
                          <Form.Check
                            key={opt} type="radio" label={opt}
                            name={`facility_${item.id}`}
                            checked={facilityValues[item.id] === opt}
                            onChange={() => handleFacilityChange(item.id, opt)}
                          />
                        ))}
                      </div>
                    )}

                    {item.type === "file" && (
                      <>
                        <Form.Control
                          type="file"
                          accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                          onChange={(e) => handleFacilityFileChange(item.id, e.target.files)}
                        />
                        {facilityDocuments[item.id]?.length > 0 && (
                          <ul className="mt-1 mb-0 small list-unstyled">
                            {facilityDocuments[item.id].map((file, idx) => {
                              const isImage = file.url
                                ? file.url.match(/\.(jpeg|jpg|png|gif)$/i)
                                : file.type?.startsWith("image/");
                              const isVideo = file.url
                                ? file.url.match(/\.(mp4|webm|ogg|mov|quicktime)$/i)
                                : file.type?.startsWith("video/");
                              const fileUrl = file.url
                                ? getFullImageUrl(file.url)
                                : URL.createObjectURL(file);
                              return (
                                <li key={idx} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "6px" }}>
                                  {isImage ? (
                                    <img src={fileUrl} alt="preview" style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 4 }} />
                                  ) : isVideo ? (
                                    <video src={fileUrl} style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 4 }} muted />
                                  ) : (
                                    getFileIcon(file.name)
                                  )}
                                  <span style={{ flex: 1, wordBreak: "break-word" }}>{file.name}</span>
                                  <IconButton component="a" href={fileUrl} target="_blank" rel="noopener noreferrer" size="small">
                                    <VisibilityIcon />
                                  </IconButton>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </>
                    )}
                  </Form.Group>
                </Col>
              ))}
            </Row>

            <Button
              type="submit"
              className="mt-3"
              style={{ backgroundColor: "#6A8F3E", borderColor: "#6A8F3E" }}
              disabled={loading}
            >
              {loading && <Spinner animation="border" size="sm" className="me-2" />}
              {isEdit ? "Edit Property" : "Add Property"}
            </Button>
          </Form>
        )}
      </Box>
    </Container>
  );
}